import type {
  RyftPayoutMethodUpdateRequestType,
  RyftPayoutMethodUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useRyftManagementPayoutMethodUpdate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({
      payoutMethodId,
      data,
    }: {
      payoutMethodId: string;
      data: RyftPayoutMethodUpdateRequestType;
    }) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `ryft-management/accounts/payout-methods/${payoutMethodId}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<RyftPayoutMethodUpdateResponseType>(response)
            .data,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.RyftManagementAccount,
        ],
      });
    },
  });
};
